import { render, staticRenderFns } from "./TenderBets.vue?vue&type=template&id=e53d8dca&"
import script from "./TenderBets.vue?vue&type=script&lang=js&"
export * from "./TenderBets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports